<script setup lang="ts">
import GbDialog from '@/components/GbDialog.vue'

defineProps<{
  webinarsUrl: string
}>()

const isVisible = defineModel<boolean>('visible', { required: true })
</script>

<template>
  <GbDialog
    v-model:visible="isVisible"
    dialogId="lms-error-dialog"
    header="Sorry! An error has occurred."
  >
    <template #bodyContent>
      <p class="mt-2">An error has occurred accessing the On Demand Training. Our Support team has been notified of the issue. To get training now, check out our webinars
        <a
          :href="webinarsUrl"
          target="_blank"
          class="text-blue-600 hover:underline"
        >
          here</a>.
      </p>
    </template>
  </GbDialog>
</template>
